import React from 'react';

import cn from 'classnames';

import styles from './Link.module.css';

export type LinkProps = {
  size?: 'small' | 'medium' | 'large';
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, size = 'medium', children, ...props }, ref) => {
    const classNames = cn(styles.link, styles[size], className);
    return (
      <a {...props} className={classNames} ref={ref}>
        {children}
      </a>
    );
  },
);

Link.displayName = 'Link';
